<template>
  <form class="home-list-item-form" @submit.prevent="submit">
    <Field
      class="list-value-field"
      v-model="content.heading"
    />

    <Field
      class="list-value-field"
      type="textarea"
      v-model="content.text"
    />

    <div class="btn-save">
      <Btn primary>Save</Btn>
    </div>
  </form>
</template>

<script>
import Btn from '@/components/Btn'
import form from '@/mixins/form'

export default {
  name: 'HomeListItemForm',

  data() {
    return {
      content: {}
    }
  },

  mixins: [form],

  props: {
    companyId: String,
    siteId: String,
    listId: String,
    listItemId: String
  },

  computed: {},

  components: {
    Btn
  },

  methods: {
    submit() {
      let data = JSON.stringify(this.content)
      this.$emit('submit', data)
    }
  },

  mounted() {
    window.setTimeout(() => {
      this.content = JSON.parse(this.resource.value)
    }, 1000)
  }
}
</script>

<style lang="sass" scoped>
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'

.btn-save
  margin-bottom: -100px
</style>
